import { ROUTES as e } from "./routes.mjs";
import { PublicRoute as t } from "./PublicRoute.mjs";
import "react";
import { Redirect as n } from "react-router-dom";
import { useAuth as r } from "@maat/store-auth";
import { Fragment as i, jsx as a } from "react/jsx-runtime";
//#region src/RestrictedRoute.tsx
var o = ({ children: o, ...s }) => {
	let { isAuthenticated: c } = r();
	return /* @__PURE__ */ a(t, {
		...s,
		render: ({ location: t }) => c ? /* @__PURE__ */ a(i, { children: o }) : /* @__PURE__ */ a(n, { to: {
			pathname: e.HOME,
			state: { from: t }
		} })
	});
};
//#endregion
export { o as RestrictedRoute };
